var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCavericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6541 2.33989C12.3448 1.03215 10.6227 0.218743 8.78109 0.0381857C6.93943 -0.142371 5.09213 0.321095 3.55384 1.34966C2.01554 2.37822 0.881352 3.90827 0.344521 5.67918C-0.19231 7.45009 -0.0986064 9.35235 0.609649 11.0619C1.3179 12.7715 2.59692 14.1827 4.22885 15.0551C5.86077 15.9275 7.74468 16.2072 9.55968 15.8466C11.3747 15.4859 13.0085 14.5072 14.1829 13.0771C15.3573 11.6471 15.9996 9.85409 16.0005 8.0036C16.0032 6.95132 15.7972 5.90895 15.3944 4.93679C14.9917 3.96463 14.4001 3.08197 13.6541 2.33989ZM11.338 11.3411C10.6792 12.0113 9.83536 12.4696 8.91455 12.6576C7.99374 12.8455 7.03779 12.7545 6.16901 12.3961C5.30023 12.0377 4.55807 11.4283 4.03755 10.6458C3.51703 9.86334 3.24182 8.94338 3.24704 8.0036C3.24971 6.75177 3.74818 5.552 4.63336 4.66682C5.51854 3.78164 6.71832 3.28317 7.97015 3.2805C8.90993 3.27528 9.82988 3.55051 10.6124 4.07103C11.3948 4.59156 12.0043 5.33368 12.3626 6.20246C12.721 7.07124 12.812 8.02719 12.6241 8.948C12.4362 9.86881 11.9778 10.7126 11.3077 11.3715L11.338 11.3411Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCavericon);
export default __webpack_public_path__ + "static/media/Caver.icon.09777678019b6c044bd3d8a93977d530.svg";
export { ForwardRef as ReactComponent };